function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase())).replace(/\s+/g, '');
}

function hyphense(str) {
  return ('' || str).replace(/ +/g, '-').toLowerCase();
}
const makeRef = (obj) => {
  obj.ref = obj.reduce((acc, item) => { acc[camelize(item)] = item; return acc; }, {});
  obj.hypRef = obj.reduce((acc, item) => { acc[hyphense(item)] = item; return acc; }, {});
};

const contactRoles = [
  'salesManager',
  'salesSpecialist',
  'sparePartsManager',
  'sparePartsSpecialist',
  'serviceManager',
  'serviceSpecialist',
  'warrantyManager',
  'warrantySpecialist',
  'warrantyEngineer',
  'serviceAdvisor',
  'chiefAccountant',
  'accountant',
];

const contentTypes = [
  'Help',
  'Special offer',
  'News',
  'Top',
];

makeRef(contentTypes);

const priceTypes = [
  'all',
  'current',
  'archive',
  'future',
];

const transportationModes = [
  'Motor',
  'Air',
  'Rail',
  'Containerized Ocean',
  'Consolidation',
  'Less than truckload',
  'Expedited Truck',
];

const orderTypes = [
  'VOR',
  'Express',
  'Warehouse',
  'Free',
  'VIN',
];

const orderStatuses = [
  'Created',
  'Approved',
  'Posted',
  'Delivery',
  'Processing',
  'Shipped',
  'Closed',
  'Not paid',
];

const partStatuses = [
  'ОтгрузитьОбособленно',
  'Отгрузить',
  'СоСклада',
  'ИзЗаказов',
  'Обособленно',
  'Требуется',
  'НеТребуется',
];

const complaintStatuses = [
  'Registered',
  'Confirmed',
  'Rejected',
];

const requestCommentTypes = [
  'REQUEST',
  'RESPONSE',
  'FEEDBACK',
];

const requestStatuses = [
  'Created',
  'In progress',
  'Closed',
];

export {
  camelize,
  hyphense,
  contactRoles,
  contentTypes,
  priceTypes,
  transportationModes,
  orderTypes,
  orderStatuses,
  partStatuses,
  complaintStatuses,
  requestCommentTypes,
  requestStatuses,
};
